// @flow

import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  /* NavLink, */
  Navigate,
} from "react-router-dom";
import styled from 'styled-components';
/* import GraphqlPlayground from './components/GraphqlPlayground.js';
import GraphqlVoyager from './components/GraphqlVoyager.js'; */
import AsyncApiDocs from './components/AsyncApiDocs.js';
/* import HuddleLogoIcon from "./HuddleLogoIcon.js"; */
import "./App.css";

const Container = styled.div`
  height: 100%;
  width: 100%;
`;

function App() {

  return (
    <Router>
      <div>
        {/* <div className="navbar-wrapper">
          <HuddleLogoIcon />
          {<div className="navbar-item">
            <NavLink
              to="/explorer"
              className={({ isActive }) => isActive ? "active-route": ''}
            >
              GraphQL Explorer
            </NavLink>
          </div>
          <div className="navbar-item">
            <NavLink
              to="/voyager"
              className={({ isActive }) => isActive ? "active-route": ''}
            >
              GraphQL Voyager
            </NavLink>
          </div>}
          <div className="navbar-item">
            <NavLink
              to="/asyncapi"
              className={({ isActive }) => isActive ? "active-route": ''}
            >
              Async API
            </NavLink>
          </div>
        </div> */}
        <Container>
          <Routes>
            <Route exact path="/" element={<Navigate to="/asyncapi" />} />
            {/* <Route path="/explorer" element={<GraphqlPlayground />} />
            <Route path="/voyager" element={<GraphqlVoyager />} /> */}
            <Route path="/asyncapi" element={<AsyncApiDocs />} />
          </Routes>
        </Container>
      </div>
    </Router>
  );
}

export default App;
